.CommandPaletteResults {
    max-height: 360px;
    overflow-y: auto;
}

.CommandPaletteGroup__header {
    padding: 14px 12px 6px;
    font-size: 11px;
    font-weight: var(--soniq-t--global--font--weight--semibold);
    text-transform: uppercase;
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    color: var(--soniq-t--global--text--color--label--default);
    font-family: var(--soniq-t--global--font--family--sans);
}

.CommandPaletteItem {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background 0.1s ease;

    &:hover:not(.isActive) {
        background: var(--soniq-t--global--background--color--surface--hover);
    }

    &.isActive {
        background: var(--soniq-t--global--background--color--accent--active--default);
        border-color: var(--soniq-t--global--border--color--accent--active--default);
    }
}

.CommandPaletteItem__icon {
    flex-shrink: 0;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--soniq-t--global--text--color--hint--default);
    font-size: 18px;

    .isActive & {
        color: var(--soniq-t--global--text--color--brand--default);
    }
}

.CommandPaletteItem__text {
    flex: 1;
    min-width: 0;
}

.CommandPaletteItem__label {
    font-size: 14.5px;
    font-family: var(--soniq-t--global--font--family--sans);
    font-weight: var(--soniq-t--global--font--weight--regular);
    color: var(--soniq-t--global--text--color--primary--default);
    line-height: 1.3;

    mark {
        background: var(--soniq-t--global--background--color--accent--active--default);
        color: var(--soniq-t--global--text--color--brand--default);
        border-radius: 3px;
        padding: 0 2px;
    }
}

.CommandPaletteItem__subtitle {
    font-size: var(--soniq-t--global--font--size--date);
    font-family: var(--soniq-t--global--font--family--sans);
    color: var(--soniq-t--global--text--color--secondary--default);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;

    mark {
        background: rgba(240, 71, 112, 0.28);
        color: var(--soniq-t--global--text--color--brand--default);
        border-radius: 3px;
        padding: 0 2px;
    }
}

.CommandPaletteItem__right {
    flex-shrink: 0;
    display: flex;
    align-items: center;

    .isActive & {
        opacity: 0;
    }
}

.CommandPaletteItem__enter {
    display: none;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: var(--soniq-t--global--text--color--brand--default);
    border: 1px solid var(--soniq-t--global--border--color--accent--active--default);
    border-radius: 4px;
    padding: 1px 5px;
    line-height: 1.4;
    font-family: var(--soniq-t--global--font--family--sans);

    .isActive & {
        display: inline-flex;
    }
}
